import { CONTACT, WHATSAPP } from '../../constants';
import './location.css';

function Location() {
  return (
    <section className="section location">
      <div className="container">
        <div className="location__grid">
          <div className="location__info">
            <span className="section-label">Visitanos</span>
            <h2 className="section-title">Encontranos en Santa Rosa</h2>
            <div className="location__details">
              <p><strong>EcoClean</strong></p>
              <p>{CONTACT.fullAddress}</p>
              {/* ⚠️ PENDIENTE: agregar horarios cuando la dueña los confirme */}
              {/* <p className="location__schedule">Lunes a viernes de 9 a 18hs · Sábados de 9 a 13hs</p> */}
            </div>
            <div className="location__actions">
              <a
                href={`https://www.google.com/maps/dir/?api=1&destination=${CONTACT.mapLat},${CONTACT.mapLng}`}
                target="_blank"
                rel="noreferrer"
                className="btn btn-outline-dark"
              >
                Cómo llegar
              </a>
              <a href={WHATSAPP.url} target="_blank" rel="noreferrer" className="btn btn-whatsapp">
                WhatsApp
              </a>
              <a href={CONTACT.instagram} target="_blank" rel="noreferrer" className="btn btn-outline-dark">
                Instagram
              </a>
            </div>
          </div>
          <div className="location__map">
            <iframe
              title="Ubicación EcoClean"
              src={`https://www.openstreetmap.org/export/embed.html?bbox=${CONTACT.mapLng - 0.01}%2C${CONTACT.mapLat - 0.01}%2C${CONTACT.mapLng + 0.01}%2C${CONTACT.mapLat + 0.01}&layer=mapnik&marker=${CONTACT.mapLat}%2C${CONTACT.mapLng}`}
              width="100%"
              height="100%"
              style={{ border: 0, minHeight: 280 }}
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default Location;
